import React from 'react';
import './style/ModalDeliveryOrder.css';

const ModalDeliveryOrder = ({ isOpen, onClose, onPaymentSuccess, onPaymentFailure }) => {
    const handleClickOutside = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modaldeliveryorder-modal-overlay" onClick={handleClickOutside}>
            <div className="modaldeliveryorder-modal-content">
                <button className="modaldeliveryorder-close-button" onClick={onClose}>✖</button>
                <h2>Оплата заказа</h2>
                <div className="modaldeliveryorder-modal-buttons">
                    <button onClick={onPaymentSuccess}>Оплата прошла</button>
                    <button onClick={onPaymentFailure}>Оплата не прошла</button>
                </div>
            </div>
        </div>
    );
};

export default ModalDeliveryOrder;
